<template>
  <v-dialog v-model="showModal" max-width="700px" persistent>
    <v-card flat>
      <v-toolbar dark class="primary">
        <v-btn icon @click.native="showModal = false" dark>
          <v-icon>fa-times</v-icon>
        </v-btn>
        <v-toolbar-title>Dodawanie terminu wizyty rezerwowej</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" lg="6" md="6" sm="12">
            <v-menu
                v-model="showSearchDate1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                    v-model="dateStart"
                    label="Data początkowa"
                    prepend-icon="fa-calendar-alt"
                    placeholder="Wybierz datę"
                    readonly
                    v-on="on"
                    clearable
                ></v-text-field>
              </template>
              <v-date-picker v-model="dateStart" @input="showSearchDate1 = false" no-title scrollable locale="pl-PL"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" lg="6" md="6" sm="12">
            <v-menu
                v-model="showSearchDate2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                    v-model="dateEnd"
                    label="Data końcowa"
                    prepend-icon="fa-calendar-alt"
                    placeholder="Wybierz datę"
                    readonly
                    v-on="on"
                    clearable
                ></v-text-field>
              </template>
              <v-date-picker v-model="dateEnd" @input="showSearchDate2 = false" no-title scrollable locale="pl-PL" ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" lg="6" md="6" sm="12"><TimePicker v-model="startTime" text="Godzina początek"></TimePicker></v-col>
          <v-col cols="12" lg="6" md="6" sm="12"><TimePicker v-model="endTime" text="Godzina koniec"></TimePicker></v-col>
        </v-row>
        <v-row>
          <v-col><v-checkbox label="Pon" v-model="mon" :disabled="mon_disabled"></v-checkbox> </v-col>
          <v-col><v-checkbox label="Wto" v-model="tue" :disabled="tue_disabled"></v-checkbox> </v-col>
          <v-col><v-checkbox label="Śro" v-model="wed" :disabled="wed_disabled"></v-checkbox> </v-col>
          <v-col><v-checkbox label="Czw" v-model="thr" :disabled="thr_disabled"></v-checkbox> </v-col><v-col></v-col>
          <v-col><v-checkbox label="Pią" v-model="fri" :disabled="fri_disabled"></v-checkbox> </v-col>
          <v-col><v-checkbox label="Sob" v-model="sat" :disabled="sat_disabled"></v-checkbox> </v-col>
          <v-col><v-checkbox label="Nie" v-model="sun" :disabled="sun_disabled"></v-checkbox> </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn color="success" @click="save()">Zapisz</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="error" @click="showModal = false">Zamknij</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import dayjs from "dayjs";
import swal from "sweetalert";
import TimePicker from "@/components/shared/TimePicker";

export default {
  name: "ReserveAddSchedule",
  components: {TimePicker},
  props: ["visible"],
  data() {
    return {
      startTime: null,
      endTime: null,
      dateStart: null,
      dateEnd: null,
      mon: false,
      tue: false,
      thr: false,
      wed: false,
      fri: false,
      sat:false,
      sun: false,
      mon_disabled: false,
      tue_disabled: false,
      wed_disabled: false,
      thr_disabled: false,
      fri_disabled: false,
      sat_disabled: false,
      sun_disabled: false,
      showSearchDate1: false,
      showSearchDate2: false
    }
  },
  methods: {
    save() {
      let anyChecked = this.mon || this.tue || this.wed || this.thr || this.fri || this.sat || this.sun
      if(!(this.dateStart && this.dateEnd) && !anyChecked)
      {
        this.showError("Proszę wybrać przedział dat lub któreś z dni tygodnia.")
        return
      }
      if((this.startTime && !this.endTime) || (this.endTime && !this.startTime))
      {
        this.showError("Proszę określić pełny przedział godzin, lub wyzerować wartośći.")
        return
      }
      this.$emit('OnAddSchedule', {
        dateStart: this.dateStart,
        dateEnd: this.dateEnd,
        startTime: this.startTime,
        endTime: this.endTime,
        mon: this.mon,
        tue: this.tue,
        wed: this.wed,
        thr: this.thr,
        fri: this.fri,
        sat: this.sat,
        sun: this.sun
      })
    },
    showError(text, close) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
            if (close) {
              this.showModal = false
            }
          })
    },
    datesChanged() {
      this.mon_disabled = false
      this.tue_disabled = false
      this.wed_disabled = false
      this.thr_disabled = false
      this.fri_disabled = false
      this.sat_disabled = false
      this.sun_disabled = false
      this.mon = false
      this.tue = false
      this.wed = false
      this.thr = false
      this.fri = false
      this.sat = false
      this.sun = false

      if(this.dateStart && this.dateEnd)
      {
        const date1 = dayjs(this.dateStart)
        const date2 = dayjs(this.dateEnd)
        if(date2 < date1)
        {
          this.showError("Data końcowa nie może być mniejsza niż początkowa")
          this.dateEnd = this.dateStart
          return
        }
        let result = date2.diff(date1,'d')
        let loopDate = date1
        while(true)
        {
          let dayWeekNumber = loopDate.format('d')
          this.checkWeekDay(dayWeekNumber)
          if(date2.diff(loopDate,'d') === 0)
            break;
          loopDate = loopDate.add(1,'day');
        }
        if(!this.sun) this.sun_disabled = true
        if(!this.mon) this.mon_disabled = true
        if(!this.tue) this.tue_disabled = true
        if(!this.wed) this.wed_disabled = true
        if(!this.thr) this.thr_disabled = true
        if(!this.fri) this.fri_disabled = true
        if(!this.sat) this.sat_disabled = true

      }
    },
    checkWeekDay(day)
    {
      switch(Number(day))
      {
        case 0:
          this.sun = true
          break;
        case 1:
          this.mon = true
          break;
        case 2:
          this.tue = true
          break;
        case 3:
          this.wed = true
          break;
        case 4:
          this.thr = true
          break;
        case 5:
          this.fri = true
          break;
        case 6:
          this.sat = true
          break;
      }
    }
  },
  computed: {
    showModal: {
      get: function () {
        return this.visible
      },
      set: function (value) {
        if (!value) {
          this.$emit('close')
        }

      }
    }
  },
  watch: {
    dateStart() {
      this.datesChanged()
    },
    dateEnd() {
      this.datesChanged()
    }
  }
}
</script>

<style scoped>

</style>
